import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import showRegistrationClosedAlert from "../utils/registrationClosedAlert.js";
import "../style/scholarshipinfo.css";

const scholarships = [
  {
    sectionClass: "custom-section1-scholarship",
    label: "01",
    type: "merit",
    title: "Leadership Scholarship",
    description:
      "Participating in leaders’ journey of growth has always become the mission of Cutting Edge Academy. This scholarship is designed for leaders who are making ample contributions to the community, yet looking to deepen their roots in the Word.",
  },
  {
    sectionClass: "custom-section2-scholarship",
    label: "02",
    type: "need-based",
    title: "Opportunity Scholarship",
    description:
      "Providing an opportunity to learn to those who are in need is a conviction that Cutting Edge Academy has. This scholarship is designed to assist students who are facing financial challenges and need help paying for educational expenses.",
  },
];

const ScholarshipInfoPage = ({ setLocation, formStatus }) => {
  const address = useLocation();
  const navigate = useNavigate();

  // Formulir scholarship bisa ditutup admin lewat Dashboard Admin.
  const handleApply = (scholarship) => {
    if (formStatus && formStatus.scholarship) {
      showRegistrationClosedAlert();
      return;
    }
    navigate("/applyscholarship", {
      state: { type: scholarship.type, label: scholarship.title },
    });
  };

  useEffect(() => {
    if (setLocation) setLocation(address);
  }, []);

  return (
    <main className="custom-page-scholarship">
      {scholarships.map((s, index) => (
        <React.Fragment key={s.type}>
          {index !== 0 && <div className="custom-divider-scholarship" />}

          <div className={s.sectionClass}>
            {/* Decorative background number */}
            <span className="custom-bgnum-scholarship" aria-hidden="true">
              {s.label}
            </span>

            <div className="custom-inner-scholarship">
              {/* Label */}
              <p className="custom-label-scholarship">{s.label}</p>

              {/* Title */}
              <h2 className="custom-title-scholarship">{s.title}</h2>

              {/* Description */}
              <p className="custom-desc-scholarship">{s.description}</p>

              {/* Apply Button */}
              <button
                className="custom-btn-scholarship"
                onClick={() => handleApply(s)}
              >
                Apply Now
                <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>
        </React.Fragment>
      ))}
    </main>
  );
};

export default ScholarshipInfoPage;
